module.exports = __webpack_public_path__ + "static/media/facebook.1d93ed4e.png";